import styled from '@emotion/styled';
import { Box, Typography, TypographyProps } from '@mui/material';
import { primaryPalette } from '../../../theme';

export const Title = styled(Typography)<TypographyProps>`
 padding-left: 8px;
 margin-bottom: -28px;
 z-index: 1;
 font-size: 2.5em;
 text-shadow: 4px 4px black;
`;

export const ImageContainer = styled(Box)`
 display: flex;
 flex-direction: column;
 align-items: center;
`;

export const ImageBodyContainer = styled(Box) <React.ImgHTMLAttributes<HTMLImageElement>>`
 width: auto;
 height: 200px;
 filter: drop-shadow(0 4px 2px black);
`;

export const DescriptionBuild = styled(Typography)`
 padding-top: 16px;
 text-shadow: 1px 1px black;
`;

export const BuildContainer = styled(Box)`
 display: flex;
 justify-content: center;
 background: ${primaryPalette[300]};
 padding: 4px;
 border-radius: 5px;
 gap: 8px;
`;

export const ImageBuildContainer = styled(Box) <React.ImgHTMLAttributes<HTMLImageElement>>`
 max-width: 80px;
 width: 19vw;
 height: auto;
`;
